/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookedAppointment { 
    startDate: string;
    beforeCancellationPeriod: boolean;
    cancellationPeriodInHours: number;
}
export const BookedAppointment_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookedAppointment_beforeCancellationPeriod_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookedAppointment_cancellationPeriodInHours_Validators: ValidatorFn[] =
    [  Validators.required, ];


